import React from "react";
import BusinessCard from "../components/BusinessCard";

const BusinessCardRoute = () => {
  return <BusinessCard />;
};

export default BusinessCardRoute;
